import { FE_SimpleBot } from "../models/integration";
import { ScalarClientApiService } from "../services/scalar/scalar-client-api.service";
import { ToasterService } from "@shared/services/toaster.service";
import { TranslateService } from "@ngx-translate/core";
import { LogService } from "@shared/services/log.service";

export class SimpleBotController {
    constructor(
        public readonly bot: FE_SimpleBot,
        private readonly scalar: ScalarClientApiService,
        private readonly toaster: ToasterService,
        private readonly translate: TranslateService,
        private readonly logService: LogService,
    ) {
    }

    public async addBotToRoom(roomId: string, key: string) {
        if (this.bot._inRoom) {
            return;
        }
        const promise = this.scalar.addBotToRoom(roomId, key);
        this.bot._inRoom = !this.bot._inRoom;
        this.bot._isUpdating = true;
        try {
            await promise;
            this.bot._isUpdating = false;
            this.translate.get('Add bot successfully').subscribe((translated: string) => {
                this.toaster.pop("success", translated);
            });
        } catch (err: any) {
            this.bot._inRoom = !this.bot._inRoom; // revert the status change
            this.bot._isUpdating = false;
            this.logService.error(err);
            this.translate.get('Cannot invite bot to room').subscribe((translated: string) => {
                this.toaster.pop("error", `${translated}`);
            });
        }
    }
}
